export const MOBILE_CARD_WIDTH = 282;
export const TABLET_CARD_WIDTH = 312;

export const PROMOTION_HEADER_HEIGHT = 11.93;
export const PROMOTION_HEADER_HEIGHT_TABLET = 21.87;
export const PROMOTION_HEADER_HEIGHT_MOBILE = 17.62;

export const VENUE_PROMOTIONS = 'Venue Promotions';
export const VIEW_ALL = 'View all';
export const PROMOTION_CARD = 'Promotion card';
export const PROMOTION_DOCUMENTS = 'Promotion documents';
export const PROMOTION_PAGE = 'promotion_page';

export const PROMOTION_TYPE_LOCALE_STRINGS: Map<string, string> = new Map([
  ['AMOUNT', '_promotion_type_amount'],
  ['PERCENTAGE', '_promotion_type_percentage'],
  ['RATES', '_promotion_type_rates']
]);

export const OFFERING = 'OFFERING_PROMOTION';
export const PLANNER = 'PLANNER_PROMOTION';
export const PROMOTIONS = 'promotions';
